import React from "react";
import useEventDetails from "../../hooks/useEventDetails";
import { ArticleBar } from "./aboutStyles";
import { useEventContext } from "../../context/EventProvider";

const Articles = () => {
  const { event: { description, virtualDescription } } = useEventContext();
  const { virtual } = useEventDetails();

  return (
    <ArticleBar id="about">
      <div className="wrapUp">
        <h1>About</h1>
        <p>{virtual ? virtualDescription : description}</p>
      </div>
    </ArticleBar>
  );
};

export default Articles;
